import script from "./TaoTeChingView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaoTeChingView.vue?vue&type=script&setup=true&lang=js"

import "./TaoTeChingView.vue?vue&type=style&index=0&id=53c900b6&lang=scss&scoped=true"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c900b6"]])

export default __exports__